import React from "react";
import styled from "styled-components";
import { CreationMenuContent } from "./creationMenuContent";
import { TopBarMobileNavList } from "./topBarNavItems";
import { useTopBarNavigation } from "./useTopBarNavigation";

interface TopBarMobileMenuContentProps {
	onClose: () => void;
	unreadMessages: number;
	profileId: string;
}

export const TopBarMobileMenuContent: React.FC<TopBarMobileMenuContentProps> = ({
	onClose,
	unreadMessages,
	profileId,
}) => {
	const navigation = useTopBarNavigation({ onAfterNavigate: onClose });

	return (
		<Container>
			<TopBarMobileNavList navigation={navigation} profileId={profileId} unreadMessages={unreadMessages} />
			<CreationSection>
				<CreationMenuContent />
			</CreationSection>
		</Container>
	);
};

const Container = styled.div`
	padding-bottom: 20px;
`;

const CreationSection = styled.div`
	margin-top: 10px;
	border-top: 1px solid ${({ theme }) => theme.colors.lightergray};
	padding-top: 24px;
`;
